import { useSelector } from "react-redux";
import { Box, Container, Paper, Typography } from "@mui/material";
import { Confirm } from "../Modal";
import ButtonAdd from "./ButtonAdd";

const CustomContainer = ({ title = '', fnConfirm, content, forms, size = 'lg', children }) => {
    const { id } = useSelector(state => state.modal);
    return(
        <Container component={Paper} sx={{ p: '2em' }} maxWidth={size}>
            <Box display={'flex'} sx={{ justifyContent: 'space-between' }} >
                <Typography variant="h4">{title.toUpperCase()}</Typography>
                <ButtonAdd />   
            </Box>
            {children}
            <br />
            {content}
            {forms}
            <Confirm fn={fnConfirm({id})} />
        </Container>
    )
}

export default CustomContainer;